// Central content + asset references for FOUND by Dream Big Entertainment

export const GREEN = "#21E065";
export const GREEN_HOVER = "#2BE080";

export const FOUND_LOGO = "/found/logo.png";
export const DREAM_BIG_LOGO = "/colour-cubes/dream-big-ent.webp";

export const SHOTS = {
  splash: "/found/shot-splash.webp",
  role: "/found/shot-role.webp",
  scout: "/found/shot-scout.webp",
  scoutProfile: "/found/shot-scout-profile.webp",
  feed: "/found/shot-feed.webp",
  artistProfile: "/found/shot-artist-profile.webp",
  grow: "/found/shot-grow.webp",
  extra1: "/found/shot-extra-1.webp",
  extra2: "/found/shot-extra-2.webp",
  extra3: "/found/shot-extra-3.webp",
  extra4: "/found/shot-extra-4.webp",
};

// Forgot AI (separate Dream Big Entertainment product) — light cream palette
export const LIME = "#C8EC63";
export const INK = "#16211B";
export const CREAM = "#F6F6F1";

export const FORGOT_SHOTS = {
  home: "/forgot/IMG_0904.PNG",

  detail: "/forgot/IMG_0906.PNG",

  lists: "/forgot/IMG_0908.PNG",
};

export const DREAM_BIG_PRODUCTS = [
  { label: "Colour Cubes — Mobile Game", to: "/colour-cubes" },
  { label: "Forgot AI — Memory Assistant", to: "/forgot-ai" },
];

export const NAV_LINKS = [
  { label: "HOW IT WORKS", to: "/#how-it-works", hash: "#how-it-works" },
  { label: "ARTISTS", to: "/#artists", hash: "#artists" },
  { label: "SCOUTS", to: "/#scouts", hash: "#scouts" },
  { label: "ABOUT", to: "/about" },
  { label: "CONTACT", to: "/contact" },
];

export const FOOTER_LEGAL = [
  { label: "Legal & Support Hub", to: "/found/legal" },
  { label: "Privacy Policy", to: "/found/privacy" },
  { label: "Terms of Service", to: "/found/terms" },
  { label: "Community Guidelines", to: "/found/community-guidelines" },
  { label: "Copyright & IP", to: "/found/copyright" },
  { label: "Delete My Account", to: "/found/delete-account" },
  { label: "Support", to: "/found/support" },
];
